import { render, staticRenderFns } from "./ParcelsShipmenstList.vue?vue&type=template&id=4b32997c&scoped=true&"
import script from "./ParcelsShipmenstList.vue?vue&type=script&lang=js&"
export * from "./ParcelsShipmenstList.vue?vue&type=script&lang=js&"
import style0 from "./ParcelsShipmenstList.vue?vue&type=style&index=0&id=4b32997c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b32997c",
  null
  
)

export default component.exports